/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import IconCardCarousel from '../../components/IconCardCarousel';
import PDIImg from '../../../../../../assets/student-training/sso/section1-img2.png';
import { FAKE_WEBSITE_CARD_ICONS } from './iconMap';
import NumberedStepsIllustration from '../../components/NumberedStepsIllustration';
import SafeBrowsing from '../../components/SafeBrowsing';
import stepIllustration from '../../../../../../assets/student-training/sso/section2-img2.png';
import stepBg1 from '../../../../../../assets/student-training/pyde/step-bg1.png';
import stepBg2 from '../../../../../../assets/student-training/pyde/step-bg2.png';
import stepBg3 from '../../../../../../assets/student-training/pyde/step-bg3.png';
import stepBg4 from '../../../../../../assets/student-training/pyde/step-bg4.png';
import stepBg5 from '../../../../../../assets/student-training/pyde/step-bg5.png';
import icon1 from '../../../../../../assets/student-training/sso/step1.png';
import icon2 from '../../../../../../assets/student-training/sso/step2.png';
import icon3 from '../../../../../../assets/student-training/sso/step3.png';
import icon4 from '../../../../../../assets/student-training/sso/step4.png';

const STEP_CARD_BACKGROUNDS = [stepBg1, stepBg2, stepBg3, stepBg4, stepBg5];

const iconMap: Record<number, string> = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
};

interface ISection1Props {
  settings: any;
}
const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const fakeWebsiteItems =
    paragraphsSettings?.items?.map((item: any, index: number) => ({
      icon: FAKE_WEBSITE_CARD_ICONS[index](false),
      title: item.title,
      content: item.content,
    })) ?? [];

  return (
    <div className="topic-section-1">
      <IconCardCarousel
        layout="top"
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.subTitle}
        description={paragraphsSettings?.description}
        illustration={<img src={PDIImg} alt="" />}
        items={fakeWebsiteItems}
        defaultActive={0}
      />
      <NumberedStepsIllustration
        mainTitle={paragraphsSettings?.section1MainTitle}
        description={paragraphsSettings?.section1Desc}
        illustration={<img src={stepIllustration} alt="" />}
        cardBackgrounds={STEP_CARD_BACKGROUNDS}
        items={paragraphsSettings?.section1Itmes}
      />
      <SafeBrowsing
        title={paragraphsSettings?.section2MainTitle}
        subTitle={''}
        description={''}
        sectionTitle={''}
        sectionDescription={''}
        slides={paragraphsSettings?.section2Items}
        icons={iconMap}
      />
    </div>
  );
};

export default Section1;
